import { render, staticRenderFns } from "./LegalAccountSidebar.vue?vue&type=template&id=7a593ef6&"
import script from "./LegalAccountSidebar.vue?vue&type=script&lang=js&"
export * from "./LegalAccountSidebar.vue?vue&type=script&lang=js&"
import style0 from "./LegalAccountSidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
